var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramOutline = function SvgTelegramOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.61 3.274a1.13 1.13 0 0 0-1.144-.196L2.133 12.99a1.777 1.777 0 0 0 .304 3.401l6.564 1.29V25a1.99 1.99 0 0 0 1.25 1.854 1.99 1.99 0 0 0 2.189-.466l3.165-3.283 5.02 4.395a1.99 1.99 0 0 0 1.94.401 1.98 1.98 0 0 0 1.333-1.453l5.074-22.073a1.13 1.13 0 0 0-.361-1.101m-7.642 4.5L9.77 15.794l-6.2-1.216zM11.001 25v-5.935l3.099 2.717zm10.941 1-10.335-9.062L26.482 6.275z"
  })));
};
export default SvgTelegramOutline;